import { Country } from "@/types/Country";
import { Language } from "@/types/Language";

// Used by the "Search this area" button
export const reverseGeocode = async ({
  lat,
  lon,
  country,
  language
}: {
  lat: number;
  lon: number;
  country?: Country;
  language?: Language;
}) => {
  if (!country || !language) {
    return;
  }

  try {
    const reverseGeocodeResponse = await fetch(
      `/api/reverse-geocode?lat=${lat}&lon=${lon}&country=${country}&language=${language}`,
      { cache: "no-store" }
    );

    if (!reverseGeocodeResponse.ok) {
      return;
    }

    const geoPlace = await reverseGeocodeResponse.json();

    let address = geoPlace.address;

    if (geoPlace.locality && geoPlace.regionCode) {
      address = `${geoPlace.locality}, ${geoPlace.regionCode}`;
    }

    if (!geoPlace || !geoPlace.address || typeof geoPlace.address !== "string") {
      return;
    }

    return {
      id: `map_${lat}_${lon}_${address}`,
      latitude: lat,
      longitude: lon,
      address
    };
  } catch (error) {
    return;
  }
};
